import { render, staticRenderFns } from "./TheUpnextDialog.vue?vue&type=template&id=a5fa696c&scoped=true&"
import script from "./TheUpnextDialog.vue?vue&type=script&lang=js&"
export * from "./TheUpnextDialog.vue?vue&type=script&lang=js&"
import style0 from "./TheUpnextDialog.vue?vue&type=style&index=0&id=a5fa696c&scoped=true&lang=css&"
import style1 from "./TheUpnextDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fa696c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomSheet,VBtn,VCard,VCol,VContainer,VIcon,VImg,VRow})
